import { gql, useLazyQuery } from "@apollo/client";
import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import useProcessData from "../../../../CommonFunction/ProcessData";
import { LoadTable, Loading } from "../../../Components";
import HeaderDiv from "../../../Components/HeaderDiv/HeaderDiv";
import { ErrorToast } from "../../../Components/ToastComponent/RectHotToast";
import useFetchTableData from "../../../custom_hooks/useFetchTableData";
import "./References.scss";

const queryfunction = (fields) => {
  const query = gql`
   query Get_All_New_Refrence_Of_Account_Id($Account_Id: ID, $newRefId: ID) {
    get_All_New_Refrence_Of_Account_Id(Account_Id: $Account_Id, newRefId: $newRefId) {
     Account_Details {
      Account_Name
      Branch_Name
    }
    References {
      _id
      ${fields?.join(" ")}
    }
  }
}`;
  return query;
};

const NewReferences = () => {
  const [formData, setFormData] = useState([]);
  const [isLoader, setIsLoader] = useState(true);
  const colAddition = ["Credit", "Debit"];
  let { id, title } = useParams();

  const config = useMemo(
    () => ({
      dataKey: "References",
      dateKeys: ["createdAt", "updatedAt"],
      deleteKeys: [
        "__typename",
        // "Amount",
        // "TransactionType",
        // "createdAt",
        // "updatedAt",
        // "UnSettled_Amount_Type",
        // "UnSettled_Amount",
      ],
      dateKeysWithoutTime: ["RefDate"],
    }),
    []
  );

  const [fetchPayable_Account_Bill_By_Bill_Details_View, { loading: queryLoading, error, data }] = useLazyQuery(
    queryfunction([]),
    {
      variables: {
        Account_Id: id,
      },
      fetchPolicy: "network-only",
      onCompleted: () => {
        setIsLoader(false);
      },
      onError: () => {
        setIsLoader(false);
      },
    }
  );

  const { TableHeaders } = useFetchTableData(
    queryfunction,
    fetchPayable_Account_Bill_By_Bill_Details_View,
    setIsLoader,
    `${title}_Account_Bill_By_Bill_Detail_View`
  );

  const { loading: processDataLoading } = useProcessData(
    data?.get_All_New_Refrence_Of_Account_Id,
    setFormData,
    config,
    error
  );

  useEffect(() => {
    if (error) {
      ErrorToast(error.message);
    }
  }, [error]);

  const isLoading = queryLoading || processDataLoading || isLoader;

  return (
    <div>
      <HeaderDiv
        title={`${title} Account Bill By Bill Detail View`}
        MoreActions={{ Is_Back: true, Is_Forword: true, Is_Add: false, Is_Edit: false }}
        TableKey={`${title}_Account_Bill_By_Bill_Detail_View`}
      />
      {data?.get_All_New_Refrence_Of_Account_Id?.Account_Details && (
        <div className="AccountDetailsDiv">
          <div>
            <p className="heading">Account Name</p>
            <p>
              {data?.get_All_New_Refrence_Of_Account_Id?.Account_Details?.Account_Name
                ? `${data?.get_All_New_Refrence_Of_Account_Id?.Account_Details?.Account_Name}`
                : "-"}
            </p>
          </div>{" "}
          <div>
            <p className="heading">Branch Name</p>
            <p>
              {data?.get_All_New_Refrence_Of_Account_Id?.Account_Details?.Branch_Name
                ? `${data?.get_All_New_Refrence_Of_Account_Id?.Account_Details?.Branch_Name}`
                : "-"}
            </p>
          </div>
        </div>
      )}
      {isLoading ? (
        <Loading />
      ) : !formData?.length ? (
        <p className="DataNotAvailable">Data not Available</p>
      ) : (
        <div className="New_References_Table_Container">
          <LoadTable
            title={`${title}_Account_Bill_By_Bill_Detail_View`}
            data={formData}
            loading={isLoading}
            error={error}
            colAddition={colAddition}
            TableHeaders={TableHeaders}
          />
        </div>
      )}
    </div>
  );
};

export default NewReferences;
